module.exports = __webpack_public_path__ + "img/Frame-95.42577eb0.svg";